module.exports = "<span>&copy; {{settings.app.year}} - {{ settings.app.name }}</span>"